<div class="reset-password-container container" #resetContainer>
    <div class="reset-password-header">
        <button mat-icon-button class="bg-transparent m-2" (click)="userCancelRecovery.emit()">
            <span class="material-symbols-rounded primary-icon">arrow_back</span>
        </button>
    </div>
    <div class="reset-password-content">
        <div class="auth-container" [ngStyle]="{ zIndex: zIndexParam }">
            <div class="reset-container">
                <div *ngIf="userIsOnEnteringData">
                    <div class="d-flex py-3">
                        <span class="material-symbols-rounded square-icon">key</span>
                        <p class="medium-text my-auto ms-3">
                            <strong>Ingresa tu cuenta</strong>
                        </p>
                    </div>
                    <div>
                        <div class="password-reset-ctrl-layout w-100">
                            <form class="w-100" [formGroup]="accountForm">
                                <app-auth-input #authInput controlName="account"
                                                accentColorForIcon="true">
                                </app-auth-input>
                            </form>
                        </div>
                        <p class="small-label py-4 m-0">
                            Si tu cuenta esta registrada y activa en nuestro
                            sistema recibirás un código de verificación para
                            continuar.
                        </p>
                    </div>
                </div>
                <div class="reset-dialog-height">
                    <div [hidden]="userIsOnEnteringData">
                        <app-sms-verification #SmsPasswordReset
                            (userHasVerifiedCode)="onUserVerifiedCode($event)">
                        </app-sms-verification>
                        <div *ngIf="userCanEnterPassword">
                            <app-password-reset-verification
                                [user]="user"
                                [channel]="channel"
                                (passwordResetted)="onPasswordResetted($event)">
                            </app-password-reset-verification>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="reset-password-bottom">
        <button *ngIf="userIsOnEnteringData"
                class="role-action-btn full-width"
                style="width: 100%"
                mat-flat-button
                type="button"
                (click)="postPasswordReset()">
            Restablecer contraseña
        </button>
        <p class="small-label m-auto py-4 text-center">
            &copy; {{ now }}. Todos los derechos reservados. Calimax.
        </p>
    </div>
</div>

<ng-template #confirmationCode>
    <div class="p-3">
        <div>
            <p class="app-module-subtitle">
                Recibiras un código de confirmación via WhatsApp:
            </p>
        </div>
        <div class="d-flex flex-column gap-3">
            <button mat-flat-button class="role-action-btn flex-grow-1"
                    (click)="dismissNotifications()">
                Continuar
            </button>
            <button mat-button
                    (click)="changeCodeChannelToSMS()">
                Enviar por SMS
            </button>
        </div>
    </div>
</ng-template>
